module.exports = {"id":"158133","name":"Jefferson Farfán","rating":"79","photo":"./data/images/photos/0/158133.png","club":{"name":"Lokomotiv Moscou","logo":"./data/images/clubs/LokomotivMoscou.png"},"positions":["MD","BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JeffersonFarfan0.json
// module id = 1966
// module chunks = 0